// source: design/src/pages/AIPage.tsx (export 2026-04-24)
/* eslint-disable max-len */
import SI from '../si/si_ja';

export default {
  // Reuse shared SI common copy to keep sub-pages aligned with SI root updates.
  common: SI.common,
  heroImage: 'si/images/hero-ai.jpg',
  heroTitle: 'AI',
  pageTitle: 'AI',
  heroSubtitle: 'Artificial Intelligence',
  heroTagline: 'AI技術を企業運営に深く統合し、データ価値を解放し、インテリジェントな意思決定を実現',
  intro: [
    '人工知能は企業の運営方法を変革しつつあります。トレンド予測からビジュアル・インテリジェント検査、インテリジェントカスタマーサービスからサプライチェーン最適化まで、AI技術は企業にかつてない効率向上とコスト最適化の可能性をもたらします。',
    '飛狼は最先端のAI技術と企業の業務シーンを深く融合させ、AI戦略立案、データガバナンス、モデル開発からシステム統合までの全工程サービスを提供し、企業のインテリジェントな変革を支援します。',
  ],
  capTitle: '核心能力',
  capSubtitle: 'Core Capabilities',
  capabilities: [
    {
      icon: 'si/si-icons/trending-up.svg',
      title: 'トレンド予測',
      desc: '設備センサーデータ、過去の業務データ、機械学習アルゴリズムに基づき、設備故障確率とサプライチェーン需要トレンドを予測。事前に保守と補充を手配し、計画外停止を30%〜50%削減し、需要予測精度を85%以上に向上させます。',
    },
    {
      icon: 'si/si-icons/eye.svg',
      title: 'ビジュアル・インテリジェント検査',
      desc: 'ディープラーニングを活用し、製品外観欠陥の自動検査を実現。検査精度が95%以上に達し、人工作業の10倍の速度で処理します。',
    },
    {
      icon: 'si/si-icons/message-square.svg',
      title: '自然言語処理',
      desc: 'インテリジェントカスタマーサービスボット、契約の自動審査、世論監視を実現し、7×24時間の自動処理を行います。',
    },
    {
      icon: 'si/si-icons/sparkles.svg',
      title: '生成AIアプリケーション',
      desc: '大規模言語モデルに基づくインテリジェントアシスタント、知識管理、コンテンツ生成により、従業員の生産性を30%以上向上させます。',
    },
    {
      icon: 'si/si-icons/database.svg',
      title: 'AIデータプラットフォーム',
      desc: 'エンタープライズ級のデータレイクとMLOpsプラットフォームにより、AIモデルのライフサイクル全体を管理します。',
    },
    {
      icon: 'si/si-icons/globe.svg',
      title: 'GEO',
      titleExtra: '（Generative Engine Optimization）',
      desc: '生成エンジン最適化。AI検索向けのコンテンツ最適化（従来のSEOとは異なる）。',
    },
  ],
  industries: [
    {
      icon: 'si/si-icons/factory.svg',
      title: '製造業',
      cases: [
        '設備予測性保全と故障診断',
        '製品品質のビジュアル検査',
        '生産スケジュールのインテリジェント最適化',
      ],
    },
    {
      icon: 'si/si-icons/shopping-cart.svg',
      title: '小売業',
      cases: [
        'インテリジェントな需要予測と補充',
        '顧客行動分析と精度マーケティング',
        'インテリジェントカスタマーサービスとアフターサポート',
      ],
    },
    {
      icon: 'si/si-icons/heart-pulse.svg',
      title: '医療・ヘルスケア',
      cases: [
        '医用画像の補助診断',
        '創薬データ分析',
        'インテリジェント健康管理',
      ],
    },
    {
      icon: 'si/si-icons/landmark.svg',
      title: '金融サービス',
      cases: [
        'インテリジェントリスク管理と詐欺防止',
        '自動レポート生成',
        '顧客プロファイリングと精度推薦',
      ],
    },
  ],
  methodTitle: 'AI導入5ステップ',
  methodTitleEn: 'Five-Step Method for AI Implementation',
  methodologySteps: [
    {
      num: '1',
      title: '業務診断',
      desc: '高価値AI活用シーンの特定',
    },
    {
      num: '2',
      title: 'データ準備',
      desc: 'データ収集、クレンジングとガバナンス',
    },
    {
      num: '3',
      title: 'モデル開発',
      desc: 'アルゴリズム選定、トレーニングと最適化',
    },
    {
      num: '4',
      title: 'システム統合',
      desc: '既存業務システムとの連携',
    },
    {
      num: '5',
      title: '継続運用',
      desc: 'モデル監視、反復と最適化',
    },
  ],
  benefits: [
    {
      number: '30%+',
      title: '運営効率向上',
      desc: '反復作業の自動化により、人的リソースを高価値タスクに集中させる',
    },
    {
      number: '25%',
      title: '意思決定精度向上',
      desc: 'データ駆動の意思決定により、人的バイアスを削減',
    },
    {
      number: '15-20%',
      title: '運営コスト削減',
      desc: '予測性保全、インテリジェント生産計画、自動化検査により総合コストを削減',
    },
    {
      number: '100%',
      title: '顧客満足度向上',
      desc: 'インテリジェントカスタマーサービスの24時間対応とパーソナライズ推薦により体験を向上',
    },
  ],
};
